export default __webpack_public_path__ + "static/media/ukvisa.20c4daa9.png";